export default __webpack_public_path__ + "static/iso9001-logo-c3285e67732fc9071ad8fc0f980ba82f.svg";